var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataUploadWarningAmber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "custom icon/warning_amber"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0007 5.98999L19.5307 19H4.4707L12.0007 5.98999Z",
    fill: "#F4C148"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 5.99L19.53 19H4.47L12 5.99ZM12 2L1 21H23L12 2ZM13 16H11V18H13V16ZM13 10H11V14H13V10Z",
    fill: "#513900"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataUploadWarningAmber);
export default __webpack_public_path__ + "static/media/data-upload-warning-amber.ce8cc2e23797906964079b26eaa606d7.svg";
export { ForwardRef as ReactComponent };